<div class="container-fluid">
  <div class="form-horizontal">
    <div class="row">
      <div class="col-sm-6">
        <h3>
          {{ 'events.attendees.management.tab-title' | translate | titlecase }}
          <span>
            <a href="https://support.weblinkinternational.com/hc/en-us/articles/115002223347" target="_blank"
              ><img src="/assets/img/help.png" title="{{ 'events.attendees.management.tab-title-help' | translate }}" class="wc-help-icon"
            /></a>
          </span>
          <span class="wl-event-attendee-refresh-link">
            <a href="#" (click)="$event.preventDefault(); resetAndSearch()">
              {{ 'common.refresh' | translate | titlecase }}
            </a>
          </span>
        </h3>
      </div>
      <div class="col-sm-6 text-right text-left-xs">
        {{ unfilteredAttendeeSearchResult.TotalCount }}
        {{ 'events.attendees.management.total-count-label' | translate | titlecase }}
        (<a href="#" (click)="$event.preventDefault(); handleAttendeesWithNoProfileIdClick()"
          >{{ unfilteredAttendeeSearchResult.AttendeesWithoutProfileCount }}
          {{ 'events.attendees.management.total-without-profileid-count-label' | translate }}</a
        >)
      </div>
    </div>

    <div class="form-group">
      <div class="col-sm-6">
        <div class="input-group">
          <input type="text" class="form-control" wl-on-enter-press (onEnterPess)="search()" [(ngModel)]="searchParams.Keyword" />
          <span class="input-group-btn">
            <button
              pButton
              type="button"
              class="btn btn-default"
              (click)="startSearch()"
              [disabled]="isSearching"
              [icon]="!isSearching ? 'pi pi-search' : ''"
            >
              <wl-busy *ngIf="isSearching" [show]="isSearching"></wl-busy>
            </button>
            <button
              pButton
              type="button"
              class="btn btn-default"
              (click)="resetAndSearch()"
              [disabled]="isSearching"
              icon="pi pi-times-circle"
            ></button>
          </span>
        </div>
      </div>

      <div class="col-sm-6">
        <select class="form-control" [(ngModel)]="searchParams.OrderBy" (ngModelChange)="getAttendees()">
          <option value="">{{ 'common.sort-by' | translate | titlecase }}</option>
          <option
            *ngFor="let sortBy of sortByFields"
            [value]="sortBy.value"
            [selected]="sortBy.value == searchParams.OrderBy ? true : null"
          >
            {{ sortBy.name }}
          </option>
        </select>
      </div>
    </div>

    <div class="form-group">
      <div class="col-xs-12">
        <button
          type="button"
          class="btn btn-sm btn-default"
          [ngClass]="{ 'wl-event-attendee-open-close-open': showAdvancedSearch }"
          (click)="toggleAdvancedSearch()"
        >
          <span class="wl-event-attendee-open-close-icon glyphicon glyphicon-chevron-down"></span>
        </button>
        {{ 'common.advancedSearch' | translate | titlecase }}
      </div>
    </div>

    <div *ngIf="showAdvancedSearch">
      <div class="form-group">
        <div class="col-sm-12">
          <p>{{ 'events.registration.management.sign-up-date-label' | translate | titlecase }}</p>

          <span class="wl-give-calendar-right-padding">
            <wl-date-selector [(ngModel)]="searchParams.SignUpStartDate" [disabled]="searchParams.SearchAnySignUpDate"></wl-date-selector>
            <wl-date-selector [(ngModel)]="searchParams.SignUpEndDate" [disabled]="searchParams.SearchAnySignUpDate"></wl-date-selector>
          </span>

          <label
            ><input type="checkbox" [(ngModel)]="searchParams.SearchAnySignUpDate" />
            {{ 'events.registration.management.search-any-date-label' | translate | titlecase }}</label
          >
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-6">
          {{ 'events.registration.management.advanced-common-criteria-label' | translate | titlecase }}
          <br />
          <label>
            <input type="checkbox" [(ngModel)]="searchParams.AllUnpaid" />
            {{ 'events.registration.management.show-all-unpaid-label' | translate | titlecase }}
          </label>
          <br />
          <label>
            <input type="checkbox" [(ngModel)]="searchParams.AllWithProfileIdNotAssigned" />
            {{ 'events.registration.management.show-all-with-no-profile-id-assigned-label' | translate | titlecase }}
          </label>
          <br />
          <label>
            <input type="checkbox" [(ngModel)]="searchParams.AllAttended" />
            {{ 'events.registration.management.show-all-attended-label' | translate | titlecase }}
          </label>
          <p>
            <button
              pButton
              type="button"
              class="btn btn-default"
              (click)="search()"
              [disabled]="isSearching"
              [icon]="!isSearching ? 'pi pi-search' : ''"
            >
              <wl-busy *ngIf="isSearching" [show]="isSearching"></wl-busy>
              <span [hidden]="isSearching">{{ 'common.search' | translate | titlecase }}</span>
              <span [hidden]="!isSearching">{{ 'common.searching' | translate | titlecase }}</span>
            </button>
          </p>
          <br />
        </div>
        <div class="col-sm-6">
          {{ 'events.registration.management.event-items-label' | translate | titlecase }}
          <div class="event-items-container">
            <div *ngFor="let item of eventItems">
              <label>
                <input type="checkbox" [(ngModel)]="item.Selected" />
                {{ item.Descr }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <div class="col-sm-12">
        <div class="input-group">
          <select class="form-control" [(ngModel)]="selectedAction" (ngModelChange)="actionChanged($event)">
            <option *ngFor="let action of actions" [value]="action.value" [selected]="action.value == selectedAction ? true : null">
              {{ action.name }}
            </option>
          </select>
          <span class="input-group-btn">
            <button pButton type="button" class="btn btn-primary" (click)="executeAction()" icon="pi pi-play-circle"></button>
            <wl-busy [show]="executing"></wl-busy>
            <img src="/assets/img/help.png" title="{{ 'events.attendees.management.actions-help' | translate }}" class="wc-help-icon" />
          </span>
        </div>
        <div class="form-group" [hidden]="selectedAction != 9">
          <label class="col-sm-3">
            {{ 'events.attendees.management.table-name-label' | translate | titlecase }}
          </label>
          <div class="col-sm-9">
            <input class="form-control" [(ngModel)]="tableName" />
          </div>
        </div>
        <div class="form-group" [hidden]="selectedAction != 11">
          <label class="col-sm-3 wl-event-attendee-custom-input">
            {{ 'events.attendees.management.custom2-label' | translate | titlecase }}
          </label>
          <div class="col-sm-9 wl-event-attendee-custom-input">
            <input class="form-control" [(ngModel)]="custom2" />
          </div>
          <label class="col-sm-3 wl-event-attendee-custom-input">
            {{ 'events.attendees.management.custom3-label' | translate | titlecase }}
          </label>
          <div class="col-sm-9 wl-event-attendee-custom-input">
            <input class="form-control" [(ngModel)]="custom3" />
          </div>
          <label class="col-sm-3 wl-event-attendee-custom-input">
            {{ 'events.attendees.management.custom4-label' | translate | titlecase }}
          </label>
          <div class="col-sm-9 wl-event-attendee-custom-input">
            <input class="form-control" [(ngModel)]="custom4" />
          </div>
          <label class="col-sm-3 wl-event-attendee-custom-input">
            {{ 'events.attendees.management.custom5-label' | translate | titlecase }}
          </label>
          <div class="col-sm-9 wl-event-attendee-custom-input">
            <input class="form-control" [(ngModel)]="custom5" />
          </div>
        </div>
      </div>
    </div>

    <div class="form-group" *ngIf="selectedAction == 5">
      <div class="col-sm-12">
        <wl-affcode-mass-add #massAddAffCode [showButtons]="false"></wl-affcode-mass-add>
      </div>
    </div>

    <p-table [showGridlines]="true"
      #attendeeDataGrid
      [lazy]="true"
      [(rows)]="pageSize"
      styleClass="wl-responsive-prime-datatable"
      [value]="attendeeSearchResult.Result"
      [paginator]="true"
      (onLazyLoad)="lazyLoadAttendees($event)"
      [totalRecords]="attendeeSearchResult.TotalCount"
    >
      <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
        <SortAltIcon *ngIf="sortOrder === 0">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
        </SortAltIcon>
        <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
        </SortAmountUpAltIcon>
        <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
        </SortAmountDownIcon>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th class="text-center wl-prime-datatable-hidden-phone" style="width: 50px">
            <input (change)="selectAll($event)" type="checkbox" />
          </th>
          <th
            class="text-center wl-prime-datatable-hidden-phone"
            style="width: 80px"
            title="{{ 'events.attendees.management.edit-attendee-tooltip' | translate }}"
          ></th>
          <th class="wl-prime-datatable-hidden-tablet-and-smaller" style="width: 120px" [pSortableColumn]="'ProfileId'">
            {{ 'common.personal-information.profile-id' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th [pSortableColumn]="'FirstName'" class="wl-prime-datatable-hidden-tablet-and-smaller">
            {{ 'common.personal-information.first-name' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th [pSortableColumn]="'LastName'" class="wl-prime-datatable-hidden-tablet-and-smaller">
            {{ 'common.personal-information.last-name' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th [pSortableColumn]="'RegistrationOrgName'" class="wl-prime-datatable-hidden-tablet-and-smaller" style="width: 230px">
            {{ 'events.attendees.management.registration-org-column-header' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th class="wl-prime-datatable-hidden-tablet-and-smaller">
            {{ 'events.attendees.management.items-column-label' | translate | titlecase }}
          </th>
          <th class="wl-prime-datatable-hidden-desktop">
            <div class="text-left wl-prime-datatable-hidden-tablet-and-bigger">
              <input (change)="selectAll($event)" type="checkbox" />
            </div>
          </th>
          <th [pSortableColumn]="'Attended'" class="text-center" style="width: 110px">
            {{ 'events.attendees.management.attended-column-label' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
          <th [pSortableColumn]="'AmountDue'" class="text-center wl-prime-datatable-hidden-phone" style="width: 80px">
            {{ 'common.revenue.paid' | translate | titlecase }}
            <p-sortIcon></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template let-attendee pTemplate="body">
        <tr>
          <td class="text-center wl-prime-datatable-hidden-phone">
            <input [(ngModel)]="attendee.Selected" (ngModelChange)="selectOrUnselectAttendee(attendee)" type="checkbox" />
          </td>
          <td class="text-center wl-prime-datatable-hidden-phone">
            <button
              pButton
              type="button"
              *ngIf="isSearching == false"
              class="btn btn-default"
              (click)="editAttendee(attendee)"
              icon="pi pi-pencil"
            ></button>
          </td>
          <td class="wl-prime-datatable-hidden-tablet-and-smaller">{{ attendee.ProfileId }}</td>
          <td class="wl-prime-datatable-hidden-tablet-and-smaller">{{ attendee.FName }}</td>
          <td class="wl-prime-datatable-hidden-tablet-and-smaller">{{ attendee.LName }}</td>
          <td class="wl-prime-datatable-hidden-tablet-and-smaller">{{ attendee.RegistrationOrgName }}</td>
          <td class="wl-prime-datatable-hidden-tablet-and-smaller">{{ attendee.ItemsDisplay }}</td>
          <td class="wl-prime-datatable-hidden-desktop">
            <div class="wl-prime-datatable-hidden-tablet-and-bigger pull-right" style="margin-left: 5px; margin-bottom: 5px">
              <button
                pButton
                type="button"
                *ngIf="isSearching == false"
                class="btn btn-xs btn-default"
                (click)="editAttendee(attendee)"
                [title]="'events.attendees.management.edit-attendee-tooltip' | translate"
                icon="pi pi-pencil"
              ></button>
            </div>
            <span class="wl-prime-datatable-hidden-tablet-and-bigger"
              ><input [(ngModel)]="attendee.Selected" (ngModelChange)="selectOrUnselectAttendee(attendee)" type="checkbox"
            /></span>
            {{ attendee.FName }} {{ attendee.LName }} ({{ attendee.ProfileId }})
            <div [hidden]="!attendee.RegistrationOrgName">
              <strong>{{ 'events.attendees.management.registration-org-column-header' | translate | titlecase }}</strong
              >: {{ attendee.RegistrationOrgName }}
            </div>
            <div [hidden]="!attendee.ItemsDisplay">
              <strong>{{ 'events.attendees.management.items-column-label' | translate | titlecase }}</strong
              >: {{ attendee.ItemsDisplay }}
            </div>
            <div class="wl-prime-datatable-hidden-tablet-and-bigger">
              <strong>{{ 'common.revenue.paid' | translate | titlecase }}</strong
              >:
              <input *ngIf="attendee.AmountDue <= 0" type="checkbox" disabled checked />
              <input *ngIf="attendee.AmountDue > 0" type="checkbox" disabled />
            </div>
          </td>
          <td class="text-center">
            <input
              [(ngModel)]="attendee.Attended"
              type="checkbox"
              (ngModelChange)="handleAttendeeAttendedCheckChanged(attendee)"
              [hidden]="attendee._updatingAttendedFlag"
            />
            <wl-busy [show]="attendee._updatingAttendedFlag"></wl-busy>
          </td>
          <td class="text-center wl-prime-datatable-hidden-phone">
            <input *ngIf="attendee.AmountDue <= 0" type="checkbox" disabled checked />
            <input *ngIf="attendee.AmountDue > 0" type="checkbox" disabled />
          </td>
        </tr>
      </ng-template>
    </p-table>
    <p-progressSpinner *ngIf="isSearching"></p-progressSpinner>
    <div>
      <select [(ngModel)]="pageSizeSelection" (ngModelChange)="handleAttendeeGridPageSizeChange($event)">
        <option value="1">{{ 'events.attendees.management.show-20-option' | translate | titlecase }}</option>
        <option value="2">{{ 'events.attendees.management.show-100-option' | translate | titlecase }}</option>
        <option value="3">{{ 'events.attendees.management.show-all-option' | translate | titlecase }}</option>
      </select>
      <span>
        <img src="/assets/img/help.png" title="{{ 'events.attendees.management.page-size-help' | translate }}" class="wc-help-icon" />
      </span>
    </div>
  </div>

  <p-dialog
    #selectEventItemsModal
    [(visible)]="showModal"
    modal="true"
    [closable]="false"
    styleClass="atlas-dialog-l"
    [focusOnShow]="false"
    [contentStyle]="{ 'max-height': '75vh' }"
  >
    <ng-template pTemplate="header" show-close="true">
      <h4 class="modal-title">{{ 'events.attendees.management.event-item-modal-title' | translate | titlecase }}</h4>
    </ng-template>

    <div class="row">
      <div class="col-sm-12">
        <div *ngFor="let eventItem of eventItems">
          <label><input type="checkbox" [(ngModel)]="eventItem.Selected" />{{ eventItem.Descr }}</label>
        </div>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <div>
        <button pButton type="button" class="btn btn-primary" (click)="flagOrUnflagAttendeesForSelectedEventItems()" icon="pi pi-bolt">
          {{ 'common.execute' | translate | titlecase }}
        </button>
        <button pButton type="button" class="btn btn-default" (click)="cancelSelectedEventItems()" icon="pi pi-ban">
          {{ 'common.cancel' | translate | titlecase }}
        </button>
      </div>
    </ng-template>
  </p-dialog>

 <app-back-to-top></app-back-to-top>
</div>
